/* Cart page: AJAX quantity, discount codes, add-ons and recommendations.
   Re-renders sections/main-cart.liquid through the Section Rendering API.
   Without JS everything falls back to plain form posts and links. */
(() => {
  const SEL = '[data-main-cart]';
  const theme = window.theme || { routes: {} };
  const R = theme.routes;
  const root = () => document.querySelector(SEL);
  const sectionId = () => (root() ? root().dataset.sectionId : null);
  let selfRendered = false;
  let recsHtml = {};

  function swap(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector(SEL);
    const current = root();
    if (!fresh || !current) return;
    const focusedId = document.activeElement && document.activeElement.id;
    current.replaceWith(fresh);
    loadRecs();
    if (focusedId) {
      const el = document.getElementById(focusedId);
      el && el.focus({ preventScroll: true });
    }
    window.TINOR && window.TINOR.init(fresh);
  }

  async function refreshSelf() {
    const id = sectionId();
    if (!id) return;
    const html = await window.TINOR.fetchSection(id);
    if (html) swap(html);
  }

  function showError(msg) {
    const el = root() && root().querySelector('[data-cart-error]');
    if (!el) { alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function setLoading(on) { root() && root().classList.toggle('is-loading', on); }

  // TINOR.changeLine re-renders cart-drawer + this section (cart:sections),
  // then fires cart:updated. Other cart changes (quick add etc.) only fire
  // cart:updated, so we fetch this section ourselves.
  document.addEventListener('cart:sections', e => {
    const id = sectionId();
    if (id && e.detail && e.detail[id]) { swap(e.detail[id]); selfRendered = true; }
  });
  document.addEventListener('cart:updated', () => {
    if (selfRendered) { selfRendered = false; return; }
    if (root()) refreshSelf().catch(() => {});
  });

  async function change(key, qty) {
    if (!window.TINOR) return false;
    setLoading(true);
    try {
      await window.TINOR.changeLine(key, Math.max(0, qty), [sectionId()]);
    } catch (err) {
      setLoading(false);
      showError(err.message);
    }
    return true;
  }

  async function updateDiscounts(codes) {
    setLoading(true);
    try {
      const res = await fetch(R.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.filter(Boolean).join(',') })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      await window.TINOR.refreshCart();
    } catch (err) {
      setLoading(false);
      showError(err.message);
    }
  }

  const currentCodes = () => (root() && root().dataset.codes ? root().dataset.codes.split(',') : []);

  function applyCode() {
    const input = root() && root().querySelector('[data-discount-input]');
    const code = input && input.value.trim();
    if (!code) return;
    const codes = currentCodes();
    if (!codes.includes(code)) codes.push(code);
    updateDiscounts(codes);
  }

  // Clicks inside the cart section (capture phase so the global theme.js
  // handlers, which would open the drawer, do not run here).
  document.addEventListener('click', e => {
    const scope = e.target.closest(SEL);
    if (!scope || !window.TINOR) return;

    const qtyLink = e.target.closest('[data-line-qty]');
    if (qtyLink) {
      e.preventDefault();
      const row = qtyLink.closest('.mc-item');
      row && row.classList.add('is-loading');
      change(qtyLink.dataset.lineQty, Number(qtyLink.dataset.qty));
      return;
    }

    const apply = e.target.closest('[data-discount-apply]');
    if (apply) { e.preventDefault(); applyCode(); return; }

    const remove = e.target.closest('[data-discount-remove]');
    if (remove) {
      e.preventDefault();
      updateDiscounts(currentCodes().filter(c => c !== remove.dataset.discountRemove));
      return;
    }

    const add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      add.classList.add('is-loading');
      fetch(R.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.addVariant), quantity: 1 }] })
      })
        .then(async res => {
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
          return window.TINOR.refreshCart();
        })
        .catch(err => { add.classList.remove('is-loading'); showError(err.message); });
    }
  }, true);

  // Typed quantities.
  document.addEventListener('change', e => {
    const input = e.target.closest(SEL + ' [data-line-input]');
    if (!input) return;
    const qty = parseInt(input.value, 10);
    if (isNaN(qty) || String(qty) === input.dataset.last) { input.value = input.dataset.last; return; }
    input.closest('.mc-item') && input.closest('.mc-item').classList.add('is-loading');
    change(input.dataset.lineInput, qty);
  });

  // Enter in the discount field applies the code; other implicit submits
  // (Enter in a quantity field) are handled by the change listener.
  document.addEventListener('submit', e => {
    const form = e.target.closest(SEL + ' [data-cart-form]');
    if (!form || !window.TINOR) return;
    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    if (document.activeElement && document.activeElement.matches('[data-discount-input]')) { applyCode(); return; }
    if (document.activeElement && document.activeElement.matches('[data-line-input]')) document.activeElement.blur();
  });

  // Order note: save quietly.
  let noteTimer;
  document.addEventListener('input', e => {
    const note = e.target.closest(SEL + ' [data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(R.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(() => {});
    }, 400);
  });

  // "Pairs well with": complementary products first, related as fallback.
  async function loadRecs() {
    const slot = document.querySelector(SEL + ' [data-cart-page-recs]');
    if (!slot || slot.dataset.loaded) return;
    slot.dataset.loaded = '1';
    const base = slot.dataset.url;
    const get = async intent => {
      const url = base + '&intent=' + intent;
      if (recsHtml[url] === undefined) {
        const html = await fetch(url).then(r => (r.ok ? r.text() : ''));
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const recs = doc.querySelector('.recs');
        recsHtml[url] = recs && recs.querySelector('.rec') ? recs.outerHTML : '';
      }
      return recsHtml[url];
    };
    try {
      const html = (await get('complementary')) || (await get('related'));
      if (html && slot.isConnected) slot.innerHTML = html;
    } catch (_) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadRecs);
  else loadRecs();
  document.addEventListener('shopify:section:load', loadRecs);
})();
